<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">
          Confirm Delete Announcement
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <div class="text-body-1">
            Are you sure you want to delete this announcement?
          </div>
          <div v-if="announcement" class="mt-3">
            <div class="text-body-2">
              <strong>Message:</strong>
              <div
                v-html="
                  announcement.announcement_message
                    ? announcement.announcement_message.substring(0, 100) +
                      (announcement.announcement_message.length > 100 ? '...' : '')
                    : '-'
                "
              ></div>
            </div>
            <div class="text-body-2 mt-2">
              <strong>Status:</strong> {{ announcement.announcement_status || '-' }}
            </div>
          </div>
          <div class="text-caption text-medium-emphasis mt-2">
            This action cannot be undone.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            variant="text"
            @click="handleClose"
            :disabled="loading"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            variant="flat"
            @click="handleDelete"
            :loading="loading"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_announcement } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "DeleteAnnouncementDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    announcement: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "deleted"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleDelete() {
      if (!this.announcement?.announcement_id) {
        return;
      }

      this.loading = true;
      try {
        // Using edit mutation to set status to DEACTIVE as delete placeholder
        const input = {
          announcement_id: this.announcement.announcement_id,
          announcement_status: "DEACTIVE",
          announcement_source: "BMS",
        };

        const response = await client.graphql({
          query: edit_announcement,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(response.data.edit_announcement);
        // console.log(responseData);

        if (responseData.status === "SUCCESS") {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Announcement deleted successfully!",
            color: "success",
          };
          this.dialog = false;
          this.$emit("deleted");
        } else {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to delete announcement",
            color: "error",
          };
        }
      } catch (error) {
        console.error("Error deleting announcement:", error);
        this.snackbar = {
          show: true,
          message: (error.errors && error.errors[0]?.message) || error.message || "An error occurred while deleting announcement",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
